import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import { FormGroup } from '@angular/forms'
import { GbEventTicketFormQuestionsService } from 'libs/shared/event-tickets/utils/src/lib/gb-event-ticket-form-questions.service'
import { GbBaseQuestion } from 'libs/shared/utils/forms/src/lib/gb-base-question'
import { GbQuestionControlService } from 'libs//shared/utils/forms/src/lib/gb-question-control.service'
import { Observable, of, take } from 'rxjs'
import {
  EventTicketCustomFieldEntity,
  EventTicketCustomValueEntity,
  EventTicketGuestStepperPayload,
} from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.models'

@Component({
  selector: 'gb-event-ticket-questions-form',
  templateUrl: './gb-event-ticket-questions-form.component.html',
  styleUrls: ['./gb-event-ticket-questions-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbEventTicketQuestionsFormComponent implements OnInit, OnChanges {
  @Output() onSubmitEvent = new EventEmitter<EventTicketGuestStepperPayload>()
  @Output() formReady = new EventEmitter<FormGroup>()
  @Input() customFields$!: Observable<EventTicketCustomFieldEntity[] | undefined>
  @Input() customValues$: Observable<EventTicketCustomValueEntity[] | undefined> = of([])
  @Input() index?: number
  @Input() shouldPrepopulateForm?: boolean
  // overrides required property of custom fields (i.e. assigning to someone else)
  @Input() allOptional?: boolean

  formattedCustomFieldQuestions$!: Observable<GbBaseQuestion<string | boolean>[]>

  questionsForm = new FormGroup({})

  constructor(
    private gbEventTicketFormQuestionsService: GbEventTicketFormQuestionsService,
    private gbQuestionControlService: GbQuestionControlService,
  ) {}

  ngOnInit(): void {
    this.setupForm()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['allOptional'] && !changes['allOptional'].isFirstChange()) {
      this.setupForm()
    }
  }

  private setupForm(): void {
    this.formattedCustomFieldQuestions$ = this.gbEventTicketFormQuestionsService.getFormattedCustomFields$(
      this.customFields$,
      this.customValues$,
      this.index,
      this.shouldPrepopulateForm,
      this.allOptional,
    )

    this.formattedCustomFieldQuestions$.pipe(take(1)).subscribe((questions) => {
      this.questionsForm = this.gbQuestionControlService.toFormGroup(questions as GbBaseQuestion<string | boolean>[])
      this.questionsForm.updateValueAndValidity()
      this.formReady.emit(this.questionsForm)
    })
  }
}
